import React, { useState } from 'react';
import get from 'lodash/get';
import omit from 'lodash/omit';
import castArray from 'lodash/castArray';
import { Parser } from 'json2csv';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons/faFileAlt';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';

import Modal from '../../../commons/components/Modal.jsx';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';
import { env } from '../../config';

import { getLang } from '~/commons/helpers';
import { getAcadYears } from '../../helpers';


const api = '/api/core/users/students';
const acadYears = getAcadYears();

function saveBlob(filename, blob) {
  if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
  } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
  }
}

const ErrorsSummary = ({errors}) => {
  var errorMap = errors.reduce((acc, r)=>{
    acc[r] = (acc[r]||0) + 1;
    return acc;
  }, {});
  return Object.keys(errorMap).map((k,i)=>(
    <div key={i}>
    X {k} ({errorMap[k]})
    </div>    
  ))
}

const CustomAlert = ({
  res,
  show,
  onHide,
}) => {
  const { t } = useTranslation();
  return (
  <Modal
    size="md"
    centered
    className="text-center p-4"
    show={show}
    onHide={onHide}
  >
    {res.status === 'error' && res.code === 400 && (
      <>
        <div className="display-2 my-3 text-danger">
          <FA icon={faTimesCircle} />
        </div>

        <h1>{t('Upload Errors')}</h1>
        <div className="text-left">
          {/* {castArray(res.payload.errors||res.payload).map((e, i) => (
            <div key={i}>
              {e}
            </div>
          ))} */}
          <ErrorsSummary errors={castArray(res.payload.errors||res.payload)} />
        </div>
        {res.payload.details && (
        <div className="mt-3">
          <button
            className="btn btn-downnload-report btn-block"
            onClick={()=>{
              console.log( res.payload.details )
              const opts = { 
                withBOM: true,
                fields: [
                  {label: 'English name /英文姓名', value: 'name.full.en'},
                  {label: 'Chinese name /中文姓名 ', value: 'name.full.zhhk'},
                  {label: 'Type /類型 ', value: 'type'},
                  {label: 'Identity /用戶身份 ', value: 'identity'},
                  {label: 'Group /組別', value: 'group'},
                  {label: 'School /學校', value: 'school'},
                  {label: 'Grade /級別', value: 'grade'},
                  {label: 'Class /班別', value: 'class'},
                  {label: 'Class No. /學號', value: 'studentId'},
                  {label: 'Email /電郵地址', value: 'email'},
                  {label: 'Password /密碼', value: 'password'},
                  {label: 'Errors', value: 'errors'},
                ]
              };
              res.payload.details.forEach((d)=>{d.errors = d.errors ? d.errors.join('\n') : d.errors});
              const parser = new Parser(opts);
              const csv = parser.parse(res.payload.details);
              console.log(csv);
              var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
              saveBlob("error_report.csv", blob);              
              onHide();
            }}
          >
            <FA icon={faDownload} />下載報告
          </button>
        </div>
        )}
      </>
    )}
  </Modal>
  )
}

const ListStudents = (props) => {
  const { school, deactivateAll } = props;
  const [alert, setAlert] = useState(false);
  const [lv, setLv] = useState('');
  const [active, setActive] = useState('');
  const [acadYear, setAcadYear] = useState('');
  const { t, i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  const filter = {};

  if (school) filter.school = school;
  if (lv) filter.lv = lv;
  if (active) filter.active = active;
  if (acadYear) filter.acadYear = acadYear;

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'name', label: 'Name' },
          { value: 'schoolClass.title', label: 'Class' },
          {
            value: 'schoolClass.grade',
            label: 'Grade',
            options: Object.keys(env.grades).map((g) => ({
              value: g,
              label: env.grades[g][lang],
            })),
          },
          { value: 'studentId', label: 'Class No.' },
          { value: 'email', label: 'Email' },
        ],
        api,
        sort: { 'name.full.en': 1 },
        filter,
        actions: env.user.roles.includes('admin') ? {
          create: school !== undefined,
          fileExport: true,
          fileImport: { 
            url: '/api/core/users/batch/import',
            customErrorAlert: CustomAlert,
            resetOnSelect: true,
          },
        } : {
          fileImport: false,
          fileExport: false,
          find: true,
          create: false,
          remove: false,
        },
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={active}
            onChange={(e) => setActive(e.target.value)}
          >
            <option value="">{t('Status')}</option>
            <option value={true}>{t('Active')}</option>
            <option value={false}>{t('Not Active')}</option>
          </select>,
          <select
            className="custom-select"
            key={1}
            value={acadYear}
            onChange={(e) => setAcadYear(e.target.value)}
          >
            <option value="">{t('Year')}</option>
            {acadYears.map((v) => (
              <option key={v} value={v}>{`${v}/${Number(v)+1}`}</option>
            ))}
          </select>,
          <select
            className="custom-select"
            key={2}
            value={lv}
            onChange={(e) => setLv(e.target.value)}
          >
            <option value="">{t('Group')}</option>
            {Object.keys(env.lvs).map((l) => (
              <option
                key={l}
                value={l}
              >{env.lvs[l][lang]}</option>
            ))}
          </select>,
        ],
        cols: [
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => getLang(r.name.full, lang),
          },
          {
            key: 'active',
            getter(v) {
              return (
                <FA icon={v ? faEye : faEyeSlash} />
              );
            },
          },
          {
            key: 'lv',
            children: 'Group',
            sortable: true,
            getter: (v) => env.lvs[v]?.[lang] ?? '',
          },
          ...(!school ? [
            {
              key: 'school.title.en',
              children: 'School',
              getter: (v, r) => getLang(get(r, 'school.title'), lang),
            },
          ] : []),
          {
            key: 'schoolClass.acadYear',
            children: 'Year',
            getter: (v) => (`${v}/${v+1}`),
          },
          {
            key: 'schoolClass.grade',
            children: 'Grade',
            getter: (v) => ( v === undefined ) ? '' : env.grades[v][lang]
          },
          {
            key: 'schoolClass.title',
            children: 'Class',
          },
        ],
        ...omit(props, 'school'),
      }}
    >
      {({ selected, refresh }) => (
        env.user.roles.includes('admin') ? 
        <>
          <ListCtrlActivates
            api={api}
            deactivateAll={deactivateAll}
            selected={selected}
            isAdmin={env.user.roles.includes('admin')}
            onSuccess={refresh}
          />
          <a
            className="btn btn-link"
            href="/api/core/users/batch/import-example"
          >
            <FA icon={faFileAlt} fixedWidth />
            &nbsp;
            {t('Import Template')}
          </a>
        </> : null
      )}
    </ListResource>
  );
};

export default ListStudents;
